import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import Button from '../../components/Button/Button';
import SelectField from '../../components/SelectField';
import CatalogItem from '../catalog-item/CatalogItem';
import Pagination from '../../components/Pagination/Pagination';
import { CustomSelect } from '../../components/CustomSelect/CustomSelect';

import FilterIcon from '../../icons/filter_icon.jpeg';

import { parserGetCategory, parserSearch } from '../../services/http';
import { getCommonLDScripts, getLDOffersList, getLDOfflineEvent } from '../../services/seo';

import {
  changeFilters,
  searchAll,
  changeCLICK,
  changeProducts,
  changePagination,
  changeSort,
  resetData,
} from '../../db/search';

import { useFilters } from '../../hooks/useFilters';
import { useQueryParams } from '../../hooks/useQueryParams';
import { useBrowserTab } from '../../hooks/useBrowserTab';

import './catalog.css';

const Catalog = (props) => {
  const {
    search,
    changeProducts,
    changePagination,
    translate,
    searchAll,
    changeSort,
    history,
    resetData,
  } = props;
  const [loading, setLoading] = useState(false);

  const { changeQueryString, getQueryParams } = useQueryParams(props);
  const {
    filtersData,
    search: searchAction,
    changeSelected,
    filtersOptions: {
      categoryOptions,
      brandOptions,
      modelOptions,
      groupOptions,
      subGroupOptions,
      statusOptions,
    },
  } = useFilters({
    ...props,
    changeQueryString,
    getQueryParams,
  });

  const fetchProducts = (data = {}) => {
    setLoading(true);
    if (data.query && !data.car && !data.category) {
      parserSearch({
        searchString: data.query,
        page: data.page,
      })
        .then((resp) => {
          if (resp && resp.id) {
            const { id } = resp;

            history.push(`/products/${id}`);
          }

          const { products, totalCount, lastAvailablePage = 100 } = resp || {};
          changeProducts(products);
          changePagination({ totalCount, lastAvailablePage });
        })
        .finally(() => setLoading(false));
    } else {
      parserGetCategory({
        categoryId: data.subType || data.type || data.category || search.category,
        page: search.pagination.page,
        marka: data.car || search.filters.car,
        model: search.filters.model || data.model,
        type: data.status,
        order: search.sort,
        /*   make: data.car || search.filters.car,
        model: search.filters.model,
        page: search.pagination.page,
        sort: search.sort,
        query: encodeURI(search.search),
        language: 'uk-UA',
        ...data,
        category: data.subType || data.type || data.category || search.category, */
      })
        .then(async (resp) => {
          const { products, totalCount, lastAvailablePage = 100 } = resp || {};

          changeProducts(products);
          changePagination({ totalCount, lastAvailablePage });

          /*  if (Number(data.query) >= 8 && !totalCount) {
        setLoading(true);
        fetch('', {
          productId: data.query,
          method: 'details',
          language: 'uk-UA',
          page: null,
          category: null,
        }).then((resp) => {
          changeProducts([resp]);
          changePagination({ totalCount: 1, lastAvailablePage: 1 });
          setLoading(false);
        });
      } */
        })
        .finally(() => setLoading(false));
    }
  };

  useBrowserTab({ tabName: 'Каталог' });

  useEffect(() => {
    return () => {
      resetData();
    };
  }, []);

  useEffect(() => {
    fetchProducts(getQueryParams());
  }, [history.location.search]);

  const extraPrice =
    parseInt((translate.find((el) => el.key === 'add_price') || {}).value) / 100 + 1;

  const prices = document.querySelector('#prices')
    ? JSON.parse(document.querySelector('#prices').value)
    : 0;

  const showPrice = (add, price) => {
    const uahRate = parseFloat(prices.uah);
    const parsedPrice = parseFloat(price);

    const priceInUAH =
      isNaN(parsedPrice) || isNaN(uahRate) ? '-' : (parsedPrice * uahRate).toFixed(0);

    if (add === 0) {
      return (
        <>
          <span className='uah'>{priceInUAH} ГРН</span>
          <br />
          <span
            style={{
              color: 'red',
              fontWeight: 'normal',
              fontSize: 12,
              display: 'block',
            }}
          >
            Цена без учёта доставки, пожалуйста уточните цену с доставкой у менеджера
          </span>
        </>
      );
    } else if (!price || isNaN(parsedPrice)) {
      return <i className='fas fa-spinner fa-spin' />;
    } else {
      return (
        <>
          <span className='uah'>{priceInUAH || '-'} ГРН</span>
        </>
      );
    }
  };

  const categoryLeft = (
    <div className='catalog__left'>
      <div className='catalog__left__select-section'>
        <SelectField
          isClearable
          onChange={(option) => {
            changeSelected('car', option.value);
            if (option.value !== filtersData.car) {
              changeSelected('model', '');
            }
          }}
          options={brandOptions}
          placeholder='Оберіть марку'
          value={brandOptions.find(({ value }) => value === String(filtersData.car)) || null}
          clearValue={() => {
            changeSelected('car', '');
            changeSelected('model', '');
          }}
        />
        <SelectField
          isClearable
          onChange={(option) => changeSelected('model', option.value)}
          options={modelOptions}
          placeholder='Оберіть модель'
          clearValue={() => changeSelected('model', '')}
          value={
            modelOptions.find(({ value }) => String(value) === String(filtersData.model)) || null
          }
        />
        <SelectField
          isClearable
          options={categoryOptions}
          placeholder='Оберіть категорію'
          onChange={(option) => {
            changeSelected('category', option.value);
            changeSelected('type', '');
            changeSelected('subType', '');
          }}
          clearValue={() => {
            changeSelected('category', '');
            changeSelected('type', '');
            changeSelected('subType', '');
          }}
          value={
            categoryOptions.find(({ value }) => String(value) === String(filtersData.category)) ||
            null
          }
        />
        <SelectField
          isClearable
          clearValue={() => {
            changeSelected('type', '');
            changeSelected('subType', '');
          }}
          options={groupOptions}
          placeholder='Оберіть групу'
          onChange={(option) => {
            changeSelected('type', option.value);
            changeSelected('subType', '');
          }}
          value={
            groupOptions.find(({ value }) => String(value) === String(filtersData.type)) || null
          }
        />
        <SelectField
          isClearable
          clearValue={() => changeSelected('subType', '')}
          options={subGroupOptions}
          placeholder='Оберіть під групу'
          onChange={(option) => changeSelected('subType', option.value)}
          value={
            subGroupOptions.find(({ value }) => String(value) === String(filtersData.subType)) ||
            null
          }
        />
        <SelectField
          isClearable
          clearValue={() => {
            changeSelected('status', '');
          }}
          options={statusOptions}
          placeholder='Оберіть стан'
          onChange={(option) => {
            changeSelected('status', option.value);
          }}
          value={
            statusOptions.find(({ value }) => String(value) === String(filtersData.status)) || null
          }
        />
        <Button onClick={searchAction}>Підібрати</Button>
      </div>
      <div className='catalog__left__all-categories'>
        <div className='catalog__left__all-categories__title'>Всі категорії</div>
        {categoryOptions.map((item) => (
          <div
            key={item.value}
            onClick={() => {
              changeSelected('category', item.value);
              changeSelected('type', '');
              changeSelected('subType', '');
              searchAll({ category: item.value });
              changeQueryString({ category: item.value, type: '', subType: '' });
            }}
            className='catalog__left__all-categories__category'
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );

  const productsTotalCount =
    (search.products || []).length * (search.pagination.lastAvailablePage || 0);
  const sortingSelect = (
    <CustomSelect
      value={search.sort}
      onChange={(value) => {
        changeSort(value);
        changeQueryString({ sort: value });
      }}
      options={[
        {
          label: 'Ціна: спочатку дешевше',
          value: 'p',
        },
        {
          label: 'Ціна: спочатку дорожче',
          value: 'pd',
        },
        {
          label: 'Популярні',
          value: 'qd',
        },
      ]}
    >
      Сортування
    </CustomSelect>
  );

  const getPrice = (price) => {
    const convertedPrice = parseFloat((parseFloat(price) + 0) * extraPrice).toFixed(0);
    const priceInUAH = parseFloat(convertedPrice * prices.uah).toFixed(0);
    const priceInUSD = parseFloat(convertedPrice * prices.usd).toFixed(0);

    return {
      priceInUAH,
      priceInUSD,
    };
  };
  const { priceInUAH: lowPriceProduct } = getPrice(
    Math.min((search.products || []).map((item) => item.price_with_delivery || item.price)),
  );
  const { priceInUAH: highPriceProduct } = getPrice(
    Math.max((search.products || []).map((item) => item.price_with_delivery || item.price)),
  );

  return (
    <>
      {!loading && (
        <Helmet
          script={[
            ...getCommonLDScripts(),
            getLDOffersList({
              products: search.products || [],
              totalCount: productsTotalCount,
              lowPrice: lowPriceProduct,
              highPrice: highPriceProduct,
            }),
            getLDOfflineEvent({
              name: 'Автозапчастини з Європи XPART',
              description:
                'Замовити нові, б/у запчастини з авторозбірок | Allegro pl ✔️ Зручний пошук ✔️Запчастини з Польщі ☎️',
              firstItemImage: ((((search.products || [])[0] || {}).images || [])[0] || {}).original,
            }),
          ]}
        >
          <meta name='author' content='Xpart' />
          <meta name='robots' content='index,follow' />
          <meta name='theme-color' content='#1a7fc8' />
          <meta name='local' property='og:local' content='uk_UA' />
          <meta name='site_name' property='og:site_name' content={window.location.hostname} />
        </Helmet>
      )}
      {loading && <div className='lmask' />}
      <section className='page-catalog__content'>
        <div className='section__content flex-container'>
          {categoryLeft}
          <div className='catalog__right'>
            <div className='catalog__right-header'>
              <div className='catalog__right-header__title'>
                {(categoryOptions.find(({ value }) => value === search.category) || {}).label}
              </div>
              <div className='catalog__right-header__sorting'>{sortingSelect}</div>
              <div className='catalog__right-header__info'>
                <div className='catalog__right-header__filter'>
                  <CustomSelect body={categoryLeft}>
                    <img src={FilterIcon} width={20} height={20} alt='filter-icon' />
                    <div>Фільтр</div>
                  </CustomSelect>
                </div>
                <div className='catalog__right-header__total-count'>
                  {sortingSelect}
                  Найдено товарів: {productsTotalCount}
                </div>
              </div>
            </div>
            <>
              <div className='catalog__right__items'>
                {(search.products || []).map((item) => (
                  <Link
                    to={`/products/${item.id}?p=${item.price_with_delivery || item.price}`}
                    key={item.id}
                  >
                    <CatalogItem
                      {...item}
                      price={showPrice(
                        item.price_with_delivery || 0,
                        parseFloat(
                          (parseFloat(item.price_with_delivery || item.price) + 0) * extraPrice,
                        ).toFixed(0),
                      )}
                    />
                  </Link>
                ))}
              </div>
              {!!(search.products || []).length && (
                <Pagination
                  page={search.pagination.page}
                  pageCount={search.pagination.lastAvailablePage}
                  onPageChange={(event) => {
                    const newPage = event.selected + 1;
                    changePagination({ page: newPage });
                    changeQueryString({ page: newPage });
                    window.scrollTo({ top: 0 });
                  }}
                />
              )}
            </>
          </div>
        </div>
      </section>
    </>
  );
};

function mapStateToProps(state) {
  return {
    user: state.user,
    cart: state.cart,
    view: state.view,
    translate: state.translate,
    search: state.search,
    ex: state.ex,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeFilters,
      searchAll,
      changeCLICK,
      changeProducts,
      changePagination,
      changeSort,
      resetData,
    },
    dispatch,
  );
}

export default withRouter(connect(mapStateToProps, matchDispatchToProps)(Catalog));
